import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { PulseLoader } from 'react-spinners';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import Checkbox from '../../../Checkbox';
import { cancelOrder } from '../../../../queries';

import {
  Padding,
  Container,
  Content,
  Button,
} from './styles';
import {
  CheckboxContainer,
  CheckboxLabel,
  Label,
  Input,
} from '../../../../assets/styles';

class CancelOrderModal extends Component {
  state = {
    loading: false,
    wirecardId: '',
    orderId: '',
    storeOrderId: '',
    userId: '',
    reason: '',
    checkedReason: new Map(),
    otherReason: false,
    reasons: ['Produto fora de estoque', 'Hórario de entrega encerrado', 'Entregadores indisponíveis', 'Fora da área de entrega', 'Outro'],
    reasonError: false,
    reasonFocus: false,
  }

  openCancelOrderModal = (wirecardId, orderId, storeOrderId, userId) => {
    this.setState({
      wirecardId,
      orderId,
      storeOrderId,
      userId,
      reason: '',
      checkedReason: new Map(),
      otherReason: false,
      reasonError: false,
    });
  }

  handleSubmit = async () => {
    await this.validateInputs();

    const {
      wirecardId,
      orderId,
      storeOrderId,
      userId,
      reason,
      checkedReason,
      reasonError,
    } = this.state;

    if (!reasonError) {
      this.setState({ loading: true });

      this.props
        .cancelOrder({
          variables: {
            storeId: this.props.store.id,
            wirecardId,
            orderId,
            storeOrderId,
            userId,
            storeName: this.props.store.name,
            reason: reason || [...checkedReason.keys()].toString(),
          },
        })
        .then(async () => {
          this.setState({ loading: false });
          this.props.close();
          this.props.alert.success('Pedido atualizado com sucesso');
        });
    }
  }

  validateInputs = () => {
    this.setState({ reasonError: false });

    const { reason, checkedReason, otherReason } = this.state;

    if (otherReason && !reason) this.setState({ reasonError: true });
    if (!otherReason && ![...checkedReason.keys()].toString()) this.setState({ reasonError: true });
  }

  handleChange = (e) => {
    const item = e.target.name;

    if (item !== [...this.state.checkedReason.keys()].toString()) {
      const isChecked = e.target.checked;
      const checkedReason = new Map();

      this.setState({ checkedReason: checkedReason.set(item, isChecked) });
    }

    if (item === 'Outro') {
      this.setState({ otherReason: true, reasonError: false });
    } else {
      this.setState({
        otherReason: false,
        reason: '',
      });
    }
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      loading,
      reasons,
      checkedReason,
      otherReason,
      reason,
      reasonError,
      reasonFocus,
    } = this.state;
    const { open, close } = this.props;

    return (
      <Modal
        open={open}
        onClose={close}
        center
        ref={(ref) => { this.cancelOrderModal = ref; }}
        styles={{
          modal: { width: '460px' },
        }}
      >
        <Container>
          <Padding>
            <h2>Cancelar pedido</h2>
          </Padding>
          <Content>
            <CheckboxContainer>
              <p>Motivo do cancelamento</p>
              <div className="checkbox">
                {reasons.map(item => (
                  <CheckboxLabel key={item}>
                    <Checkbox
                      name={item}
                      checked={checkedReason.get(item)}
                      onChange={this.handleChange}
                    />
                    <span>{item}</span>
                  </CheckboxLabel>
                ))}
              </div>
            </CheckboxContainer>
            {otherReason && (
              <Label>
                <Input
                  type="text"
                  name="reason"
                  placeholder="Informe o motivo"
                  value={reason}
                  error={reasonError}
                  onFocusInput={reasonFocus}
                  onChange={this.handleInputChange}
                  onFocus={() => this.onFocus('reasonFocus')}
                  onBlur={() => this.onBlur('reasonFocus')}
                />
              </Label>
            )}
          </Content>
          <Padding>
            <Button type="submit" disabled={loading} onClick={this.handleSubmit}>
              {!loading ? (
                'Salvar'
              ) : (
                <PulseLoader
                  sizeUnit="px"
                  size={7}
                  color="#FFFFFF"
                  loading={loading}
                />
              )}
            </Button>
          </Padding>
        </Container>
      </Modal>
    );
  }
}

export default compose(
  withAlert(),
  graphql(cancelOrder, { name: 'cancelOrder', withRef: true }),
)(CancelOrderModal);
